import { z } from 'zod';

import { reloadPage } from 'utils/navigation';

const getDeeplinkIndexStorageKey = (paymentId: string) =>
  `@deeplinks/id/${paymentId}`;

const getDeeplinkLinksSotrageKey = (paymentId: string) =>
  `@deeplinks/links/${paymentId}`;

export const openDeeplink = (link: string) =>
  new Promise((resolve) => {
    const start = Date.now();

    const checkIfAppOpened = () => {
      const now = Date.now();
      if (document.visibilityState === 'hidden') {
        resolve(true);
      } else if (now - start > 2000) {
        resolve(false);
      } else {
        requestAnimationFrame(checkIfAppOpened);
      }
    };

    window.location.href = link;
    requestAnimationFrame(checkIfAppOpened);
  });

export const deepLinksProcessingActive = (paymentId: string) =>
  !!sessionStorage.getItem(getDeeplinkIndexStorageKey(paymentId));

export const openDeeplinksWithReload = (links: string[], paymentId: string) => {
  if (deepLinksProcessingActive(paymentId)) return false;

  sessionStorage.setItem(
    getDeeplinkLinksSotrageKey(paymentId),
    JSON.stringify(links),
  );
  return true;
};

export const processDeeplinksWithReload = (paymentId: string) => {
  return new Promise<void>((resolve) => {
    const clear = () => {
      sessionStorage.removeItem(getDeeplinkLinksSotrageKey(paymentId));
      sessionStorage.removeItem(getDeeplinkIndexStorageKey(paymentId));
    };

    try {
      const links = z
        .string()
        .array()
        .parse(
          JSON.parse(
            sessionStorage.getItem(getDeeplinkLinksSotrageKey(paymentId)) ??
              '[]',
          ),
        );

      const currentLinkIndex = Number(
        sessionStorage.getItem(getDeeplinkIndexStorageKey(paymentId)) ?? '0',
      );

      const currentLink = links[currentLinkIndex];

      if (currentLink) {
        window.location.href = currentLink;
        sessionStorage.setItem(
          getDeeplinkIndexStorageKey(paymentId),
          String(currentLinkIndex + 1),
        );

        setTimeout(() => {
          reloadPage();
        }, 50);
      } else {
        clear();
        resolve();
      }
    } catch {
      clear();
      resolve();
    }
  });
};
